(function () {
	'use strict';

	angular
		.module('wizard-future7.configs', []);

	angular
		.module('wizard-future7.constants', []);

	angular
		.module('wizard-future7.directives', []);

	angular
		.module('wizard-future7.services', []);

	angular
		.module('wizard-future7.routes', []);

	angular
		.module('wizard-future7.interceptors', []);
}());